<template>
  <div class="separador-troca-atendente">
    <div class="separador-linha"></div>
    <div class="separador-conteudo">
      <div class="separador-icone" :class="{ 'icone-atribuido': isAtribuicao }">
        <i :class="isAtribuicao ? 'feather icon-user-check' : 'feather icon-repeat'"></i>
      </div>
      <div class="separador-info">
        <span class="separador-titulo">{{ tituloSeparador }}</span>
        <div class="separador-detalhes">
          <template v-if="isAtribuicao">
            <span class="atendente-novo">{{ atendenteNovo.nome }}</span>
          </template>
          <template v-else>
            <span class="atendente-anterior">{{ atendenteAnterior.nome }}</span>
            <i class="feather icon-arrow-right separador-seta"></i>
            <span class="atendente-novo">{{ atendenteNovo.nome }}</span>
          </template>
        </div>
        <span class="separador-horario">{{ timestampFormatado }}</span>
      </div>
    </div>
    <div class="separador-linha"></div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-br')

export default {
  name: 'SeparadorTrocaAtendente',
  props: {
    atendenteAnterior: {
      type: Object,
      required: true
    },
    atendenteNovo: {
      type: Object,
      required: true
    },
    timestamp: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    isAtribuicao() {
      const id = this.atendenteAnterior?.id
      return !id || id === 0 || id === '0' || id === null
    },
    tituloSeparador() {
      return this.isAtribuicao ? 'Atendimento atribuído' : 'Atendimento transferido'
    },
    timestampFormatado() {
      try {
        const data = moment(this.timestamp)
        if (!data.isValid()) {
          return ''
        }
        return data.format('D [de] MMMM, HH:mm')
      } catch {
        return ''
      }
    }
  }
}
</script>

<style scoped>
.separador-troca-atendente {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 0;
  margin: 8px 0;
}

.separador-linha {
  flex: 1;
  height: 1px;
  background: linear-gradient(to right, transparent, #ddd 50%, transparent);
}

.separador-conteudo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px;
  background: #f8f9fa;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.separador-icone {
  width: 32px;
  height: 32px;
  background: #9A3092;
  border-radius: 50%;
  color: white;
  font-size: 16px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.separador-icone.icone-atribuido {
  background: #28a745;
}

.separador-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.separador-titulo {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.separador-detalhes {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 500;
}

.atendente-anterior {
  color: #888;
}

.separador-seta {
  font-size: 14px;
  color: #9A3092;
}

.atendente-novo {
  color: #333;
  font-weight: 600;
}

.separador-horario {
  font-size: 11px;
  color: #999;
}

/* Dark mode */
body.dark-layout .separador-conteudo {
  background: #2c3e50;
  border-color: #3b4253;
}

body.dark-layout .separador-linha {
  background: linear-gradient(to right, transparent, #3b4253 50%, transparent);
}

body.dark-layout .separador-titulo {
  color: #aaa;
}

body.dark-layout .atendente-novo {
  color: #d0d2d6;
}

body.dark-layout .atendente-anterior {
  color: #999;
}

/* Mobile */
@media (max-width: 768px) {
  .separador-troca-atendente {
    padding: 12px 0;
    gap: 8px;
  }

  .separador-conteudo {
    padding: 6px 12px;
    gap: 8px;
  }

  .separador-icone {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .separador-titulo {
    font-size: 11px;
  }

  .separador-detalhes {
    font-size: 13px;
    gap: 6px;
  }

  .separador-horario {
    font-size: 10px;
  }
}
</style>
